<template>
  <form>
    <div class="settings-top-bar" ref="optionsTopBar">
      <div class="top-bar">
       <p>
          <a class="btn btn-orange btn-icon back" :title="$t('general.back')" @click.prevent="cancelZone">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
       </p>
       <p class="d-inline-flex">
          <a class="btn btn-danger btn-icon btn btn mar-rt-10 delete" v-if="!isNew" @click.prevent="deleteZone" style="padding: 7px 10px; margin-right: 20px;">
            <img src="/static/img/icons/icon-close.png">
            {{$t('general.delete')}}
          </a>
          <button type="submit" class="btn btn-icon btn-success btn mar-rt-10 save"  @click.prevent="validate" :title="$t('general.save') + ' ' + $t('settingUsers.single')">
            <img src="/static/img/icons/save.png">
            {{$t('general.save')}}
          </button>
        </p>
      </div>
    </div>
    <div class="row mar-to-15" style="display: flex; justify-content: flex-start; align-items: stretch;">
      <div class="col-lg-12 col-md-12">
        <div class="card" style="height:100%; width:100%; margin: 0;">
          <div :class="(loading ? 'show-loader' : 'hide-loader')">
            <div class="el-loading-spinner">
              <svg viewBox="25 25 50 50" class="circular">
                <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
              </svg><!---->
            </div>
          </div>
          <div class="card-content">
            <p class="text-danger" v-if="errors.has('error')">
              {{ getError('error') }}
            </p>
            <div class="row">
              <div class="col-md-12">
                 <div class="form-group">
                  <p>ID: {{model.id}}</p>
                </div>
                <div class="form-group">
                  <label>{{$t('settingTable.name')}}</label>
                  <input type="text"
                          name="name"
                          data-vv-as="name"
                          :placeholder="$t('settingTable.name')"
                          v-validate="modelValidate.name"
                          v-model="model.name"
                          class="form-control">
                  <small class="text-danger" v-if="errors.has('name')">
                    {{ getError('name') }}
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
  import Vue from 'vue'
  // import {mapFields} from 'vee-validate'
  import {Input, Upload, Button, DatePicker} from 'element-ui'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'

  Vue.use(DatePicker)
  Vue.use(Upload)
  Vue.use(Button)
  Vue.use(Input)

  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [Upload.name]: Upload,
      [Button.name]: Button,
      [Input.name]: Input
    },
    props: {
      zoneId: null,
      callback: {
        required: false
      }
    },
    watch: {
      zoneId (value) {
        this.id = value
      }
    },
    created () {
      this.apiUrl = process.env.API_BASE_URL
      this.getData()
    },
    data () {
      return {
        apiUrl: '',
        id: this.value || this.zoneId,
        isNew: true,
        model: {
          'id': 0,
          'name': ''
        },
        modelValidate: {
          name: {required: true}
          // firstname: {required: true, min: 3},
        },
        languages: this.$session.get('defaultData')['available_languages'],
        loading: true
      }
    },
    methods: {
      getData () {
        this.loading = true
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        if ((this.$route.params.id !== undefined && this.$route.params.id) ||
          (this.id !== undefined && this.id !== null)) {
          this.isNew = false
        } else {
          this.isNew = true
        }
        if (!this.isNew) {
          var id = this.$route.params.id || this.id
          this.apiRequest('/table-zone/' + id, 'GET', data, (response) => {
            if (response.status === true) {
              this.model = response.data
              this.loading = false
            }
          })
        } else {
          this.loading = false
        }
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          if (isValid) { this.saveZone() }
        })
      },
      handleErrors (errors) {
        for (var prop in errors) {
          if (errors.hasOwnProperty(prop)) {
            if (errors[prop].length === 1) {
              this.errors.add(prop, errors[prop][0])
            } else {
              this.errors.add(prop, errors[prop])
            }
          } else {
            this.errors.add('error', errors[prop])
          }
        }
      },
      saveZone () {
        this.loading = true
        let data = this.model
        data.token = this.$session.get('token')
        data.company_id = this.$session.get('selectedCompany')
        this.apiRequest('/table-zone/' + data.id, 'PUT', data, (response) => {
          if (response.success === true) {
            this.loading = false
            this.errors.clear()
            swal(
              {
                title: '',
                text: this.$t('settingTable.tableSave'),
                type: 'success',
                showConfirmButton: false,
                timer: 1500
              }
            )
            .then(() => {})
            .catch(() => {})
            this.cancelZone()
          } else {
            this.loading = false
            this.handleErrors(response.errors)
          }
        })
      },
      deleteZone () {
        var btnCounter = 10
        var self = this
        swal({
          title: self.$t('settingTable.deleteZoneTitle'),
          text: self.$t('settingTable.deleteZoneTxt'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes (' + btnCounter + ')'
        })
        .then((result) => {
          if (result) {
            this.deleteZone2()
          }
        })
        swal.disableConfirmButton()

        var btnInterval = setInterval(function () {
          btnCounter--

          if (btnCounter >= 1) {
            swal.getConfirmButton().textContent = self.$t('general.yes') + ' (' + btnCounter + ')'
          } else {
            swal.getConfirmButton().textContent = self.$t('general.yes')
            clearInterval(btnInterval)
            swal.enableConfirmButton()
          }
        }, 1000)
      },
      deleteZone2 () {
        this.loadingReset = true
        var id = this.id || this.$route.params.id
        var data = {
          company_id: this.$session.get('selectedCompany'),
          token: this.$session.get('token'),
          delete: true
        }
        this.apiRequest('/table-zone/' + id, 'PUT', data, (response) => {
          if (response.success === true) {
            this.loadingReset = false
            swal({'text': 'Saved succesfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000})
            .then(() => {})
            .catch(() => {})
            this.cancelZone()
          } else {
            this.loadingReset = false
            swal({'text': this.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000})
            .then(() => {})
            .catch(() => {})
          }
        })
      },
      cancelZone () {
        if (typeof this.callback === 'function') {
          this.callback()
        }
      }
    }
  }
</script>
<style>
  /* secret hidden css start */



  /* secret hidden css stop */
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/TableZones/TableZonesForm.vue